import axios from "axios";
import { toast } from "react-toastify";

const url = process.env.REACT_APP_API_URL;
let user = JSON.parse(localStorage.getItem("user"));

export const fetchPost = async (detail, params) => {
  let data;
  let error = false;
  try {
    data = await axios.post(url + detail, params, {
      headers: {
        Authorization: "Bearer " + user.Token,
        Accept: "*/*",
      },
    });
  } catch (errorReq) {
    // Pesan asli dari server (mis. "Barcode sudah dipakai barang MB6535").
    // `errorReq.response` bisa TIDAK ADA (jaringan putus / timeout) — dulu baris
    // ini mengaksesnya langsung sehingga kegagalan jaringan malah memunculkan
    // TypeError yang menutupi penyebab sebenarnya.
    const errMsg =
      errorReq?.response?.data?.message || errorReq?.message || "Failed to Update!";
    toast.error(`Failed to Update! ${errMsg}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    error = true;
    // Lempar error ASLI (seperti fetchPut). Sebelumnya error ditelan, lalu baris
    // `return data.data` di bawah tetap meledak karena `data` undefined — jadi
    // pemanggil menerima "Cannot read properties of undefined" alih-alih alasan
    // penolakan yang sesungguhnya.
    throw errorReq;
  }
  if (!error) {
    toast.success("Berhasil Update!", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  return data.data;
};

export const fetchPostMultipart = async (detail, params) => {
  let data;
  let error = false;
  data = await axios.post(url + detail, params, {
    headers: {
      Authorization: "Bearer " + user.Token,
      Accept: "*/*",
      "content-type": "multipart/form-data",
    },
  });
  return data.data;
};

export const fetchPostMultipartSeaweed = async (params) => {
  let data;
  let error = false;
  data = await axios.post(
    process.env.REACT_APP_API_UPLOAD_URL + "upload",
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data.data;
};

export const fetchPut = async (detail, params) => {
  let data;
  let error = false;
  try {
    data = await axios.put(url + detail, params, {
      headers: {
        Authorization: "Bearer " + user.Token,
        Accept: "*/*",
      },
    });
  } catch (errorReq) {
    const errMsg = errorReq?.response?.data?.message || errorReq?.message || "Failed to Update!";
    toast.error(`Failed to Update! ${errMsg}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    error = true;
    throw errorReq;
  }
  if (!error) {
    toast.success("Berhasil Update!", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  return data.data;
};

export const fetchPostSilance = async (detail, params) => {
  let data;
  data = await axios.post(url + detail, params, {
    headers: {
      Authorization: "Bearer " + user.Token,
      Accept: "*/*",
    },
  });

  return data.data;
};

export const fetchGet = async (detail, params) => {
  const config = {
    headers: { Authorization: `Bearer ` + user.Token },
    params: params,
  };

  const { data } = await axios.get(url + detail, config);
  return data;
};

export const fetchDelete = async (detail, params) => {
  let data;
  let error = false;
  try {
    data = await axios.delete(url + detail, {
      headers: {
        Authorization: "Bearer " + user.Token,
        Accept: "*/*",
      },
      data: params, // Untuk DELETE, data dikirim di properti data
    });
  } catch (errorReq) {
    toast.error(`Failed to Delete! ${errorReq.response?.data?.message || errorReq.message}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    error = true;
    throw errorReq;
  }
  
  if (!error) {
    toast.success("Berhasil Delete!", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  return data.data;
};
